import router from '@/router'
import store from '@/vuex'
import routerEngin from 'vue-common-laboratory/dist/router/engine'

routerEngin(router, store)



// WEBPACK FOOTER //
// ./src/router/engine.js